import React from 'react';
import styled from 'styled-components';
import titleCase from 'utils/TitleCase';
import getIn from '../../connectedForm/utils/getIn';

const Breadcrumb = styled.div``;

const Crumb = styled.div`
  display: inline-block;
  &::before {
    padding: 0 5px;
    content: '/';
    color: #aaa;
  }
  &:last-child {
    color: #aaa;
  }
`;

const BreadcrumbFormatter = (props) => {
  let value = props.value;
  let textFormat = getIn(props, 'column.options.textFormat');

  switch (textFormat) {
    case 'TITLE_CASE':
      value = titleCase(value);
      break;
  }

  let crumbs = [];

  props.value.forEach((value, index) => {
    crumbs.push(
      <Crumb key={`${value}_${index}`} title={value}>
        {value}
      </Crumb>
    );
  });
  return <Breadcrumb>{crumbs}</Breadcrumb>;
};

export default BreadcrumbFormatter;
